import AudioPlayer from './audioPlayer';

export default AudioPlayer;